import { NotificationsServiceInterface } from 'domain/services';
import {
  GetDirectorNotificationsUseCaseInterface,
  MarkDirectorNotificationAsReadUseCaseInterface,
} from 'domain/usecases';

export class NotificationsService implements NotificationsServiceInterface {
  constructor(
    private readonly _getDirectorNotificationsUseCase: GetDirectorNotificationsUseCaseInterface,
    private readonly _markDirectorNotificationAsReadUseCase: MarkDirectorNotificationAsReadUseCaseInterface,
  ) {}

  async getDirectorNotifications(
    params?: GetDirectorNotificationsUseCaseInterface.Params,
  ): Promise<GetDirectorNotificationsUseCaseInterface.Result> {
    return await this._getDirectorNotificationsUseCase.execute(params);
  }

  async markDirectorNotificationAsRead(
    params: MarkDirectorNotificationAsReadUseCaseInterface.Params,
  ): Promise<MarkDirectorNotificationAsReadUseCaseInterface.Result> {
    return await this._markDirectorNotificationAsReadUseCase.execute(params);
  }
}
